// @flow
import { ConfOpinometroActionTypes } from './constants';

const INIT_STATE = {
    confOpinometro: {},
    loading: false,
    error: false,
    formSubmited: false,
};

type ConfOpinometroAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { confOpinometro?: {} | null, listaConfOpinometro?: [] | null, loading?: boolean, +value ?: boolean };

const ConfOpinometro = (state: State = INIT_STATE, action: ConfOpinometroAction): any => {
    // console.log(action);
    switch (action.type) {
        case ConfOpinometroActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ConfOpinometroActionTypes.GET_CONF_OPINOMETRO: {
                    return {
                        ...state,
                        confOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ConfOpinometroActionTypes.UPDATE_CONF_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }


        case ConfOpinometroActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ConfOpinometroActionTypes.GET_CONF_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        confOpinometro: {},
                        loading: false,
                    };
                }
                case ConfOpinometroActionTypes.UPDATE_CONF_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ConfOpinometroActionTypes.GET_CONF_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case ConfOpinometroActionTypes.UPDATE_CONF_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case ConfOpinometroActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                confOpinometro: {},
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default ConfOpinometro;
